import http from "@/services/http";

// Prévia em tela (JSON com colunas + linhas no formato Quiver)
const preview = (params) => http.get('reports/preview', { params: params })

// Download do arquivo .xlsx no formato exato de importação do Quiver
const download = (params) => http.get('reports/export', { params: params, responseType: 'blob' })

// Troca a corretora (Finn/Acrisure) de uma apólice/endosso
const updateBroker = (policyId, broker) => http.patch(`reports/policies/${policyId}/broker`, { broker })

export default {
  preview,
  download,
  updateBroker,
}
